import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useSuspenseQuery } from '@tanstack/react-query'
import { getDeviceLinksQueryKey } from './use-get-device-links'
import { getDeviceLinks } from '../api'
import { DeviceLinkModel } from '../models'

interface UseGetDeviceLinks {
  deviceLinks: DeviceLinkModel[] | null
  isLoading: boolean
  isError: boolean
}

const useDeviceLinksSuspense = (installationId: string | undefined): UseGetDeviceLinks => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, isError } = useSuspenseQuery({
    queryKey: getDeviceLinksQueryKey(installationId),
    queryFn: async () => {
      const { error, hasErrors, value } = await getDeviceLinks(authFetch, installationId)
      if (hasErrors || error) throw new Error(error?.message)
      return value
    },
  })

  return { deviceLinks: data || null, isLoading, isError }
}

export default useDeviceLinksSuspense
